import {ServiceCategory} from "@/ui/service-block/ServiceBlock";

export const GENERAL_SERVICE_TERM_1 = "Level 2 Electrical Services";
export const GENERAL_SERVICE_TERM_2 = "Electrical";
export const GENERAL_SERVICE_TERM_3 = "Electrical";
export const serviceBlockData: ServiceCategory[] = [
    {
        title: "Level 2 Electrical Connections",
        services: [
            "Overhead Service Line Installation Sydney",
            "Underground Service Line Installation Sydney",
            "Temporary Builders Power Supply Sydney",
            "Private Pole Installation & Replacement Sydney",
            "Point of Attachment Repairs Sydney",
            "Defect Notice Rectifications Sydney",
            "Service Fuse Replacements Sydney"
        ],
        imageUrl: "/images/services/stand-alone-service-points/sas-1.jpg",
    },
    {
        title: "Metering & Power Upgrades",
        services: [
            "Electricity Meter Installation Sydney",
            "Meter Box Relocation & Upgrades Sydney",
            "Three-Phase Power Upgrades Sydney",
            "Off-Peak Meter Installation Sydney",
            "Smart Meter Installation Sydney",
            "Load Balancing for Electrical Systems Sydney",
            "Switchboard Capacity Upgrades Sydney"
        ],
        imageUrl: "/images/services/stand-alone-service-points/sas-2.jpg",
    },
    {
        title: "Specialized Level 2 Electrical Services",
        services: [
            "Disconnection & Reconnection of Power Sydney",
            "Consumer Mains Upgrades Sydney",
            "Trenching & Conduit Installation Sydney",
            "Electrical Compliance Inspections Sydney",
            "Storm Damage Electrical Repairs Sydney",
            "Private Pole Maintenance Sydney",
            "Emergency Level 2 Electrical Services Sydney"
        ],
        imageUrl: "/images/services/stand-alone-service-points/sas-3.jpg",
    },
];
